const PANAMA_TIMEZONE = 'America/Panama';

const datePartsInPanama = (value = new Date()) => {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: PANAMA_TIMEZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }).formatToParts(value);
    return Object.fromEntries(parts.map((part) => [part.type, part.value]));
};

export const panamaToday = (now = new Date()) => {
    const parts = datePartsInPanama(now);
    return new Date(
        Number(parts.year),
        Number(parts.month) - 1,
        Number(parts.day),
        12,
        0,
        0,
        0
    );
};

const shiftDays = (date, amount) => {
    const shifted = new Date(date);
    shifted.setDate(shifted.getDate() + amount);
    return shifted;
};

export const buildObservationPresetRange = (preset, now = new Date()) => {
    const end = panamaToday(now);
    if (preset === 'month') {
        return [new Date(end.getFullYear(), end.getMonth(), 1, 12), end];
    }
    const days = preset === '90' ? 90 : 30;
    return [shiftDays(end, -(days - 1)), end];
};

export const formatObservationDateParam = (date) => {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
    const parts = datePartsInPanama(date);
    return `${parts.year}-${parts.month}-${parts.day}`;
};

export const observationRangeKey = (range = []) => {
    const [from, to] = range;
    const fromValue = formatObservationDateParam(from);
    const toValue = formatObservationDateParam(to);
    return fromValue && toValue ? `${fromValue}:${toValue}` : '';
};

export const observationRangeParams = (range = []) => {
    const key = observationRangeKey(range);
    if (!key) return '';
    const [from, to] = key.split(':');
    return `from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`;
};

export const observationRangeDays = (range = []) => {
    const [from, to] = range;
    if (!(from instanceof Date) || !(to instanceof Date)) return null;
    if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) return null;
    const fromValue = formatObservationDateParam(from);
    const toValue = formatObservationDateParam(to);
    const fromUtc = Date.parse(`${fromValue}T00:00:00.000Z`);
    const toUtc = Date.parse(`${toValue}T00:00:00.000Z`);
    return Math.floor((toUtc - fromUtc) / 864e5) + 1;
};

export { PANAMA_TIMEZONE };
